var __cookieLawBannerPosition = "bottom"; // "top" o "bottom"

var __cookieLawCookiePolicyUrl = {
    ca: 'https://vila-seca.cat/politica-cookies'
    ,es: 'es/cookies/'
    ,en: '/en/cookies/'
    ,fr: '/fr/cookies/'
};

var __cookieLawTextWarning = {
    ca: 'Fem servir cookies pr&ograve;pies i de tercers per millorar aquest web, recollir i analitzar dades d&acute;acc&eacute;s, incloure funcions socials i oferir publicitat basada en els seus h&agrave;bits de navegaci&oacute;. Si segueix navegant considerem que accepta. Per canviar la configuraci&oacute; i obtenir m&eacute;s informaci&oacute;:'
    ,es: 'Utilizamos cookies propias y de terceros para mejorar esta web, recoger y analizar datos de acceso, incluir funciones sociales y mostrar publicidad basada en sus h&aacute;bitos de navegaci&oacute;n. Si contin&uacute;a navegando, consideramos que acepta. Para cambiar la configuraci&oacute;n u obtener m&aacute;s informaci&oacute;n:'
    ,en: 'We use first and third party cokies to enhance this web, collect and analyze access data, include social functions and show ads based in your browsing behavior. If you continue browsing, we assume that you accept. To change configuration and more information:'
    ,fr: 'Nous utilisons premier et troisi&egrave;me cokies pour am&eacute;liorer ce web, collecter et analyser les donn&egrave;es d&#39;acc&eacute;s, incluons des fonctions sociales et montrons des annonces en fonction de vos habitudes de navigation. Si vous continuer &agrave; naviguer, nous supposons que vous acceptez. Pour modifier la configuration et plus d&#39;informations:'
}

var __cokieLawTextPolCookiesName = {
    ca: 'pol&iacute;tica de cookies'
    ,es: 'pol&iacute;tica de cookies'
    ,en: 'cookies policy'
    ,fr: 'politique li&eacute;e aux cookies'
};

var __cokieLawTextAccept = {
    ca: 'Acceptar'
    ,es: 'Aceptar'
    ,en: 'Accept'
    ,fr: 'Accepter'
};

var __cokieLawTextReject = {
    ca: 'Rebutjar'
    ,es: 'Rechazar'
    ,en: 'Reject'
    ,fr: 'Rejeter'
};

// idioma
// este metodo debe personalizarse en base al funcionamiento idiomatico de la pagina
function __getCookieLawLang() {
    console.log(window.location.href);
    if ( window.location.href.indexOf("/ca/") != -1 ) return 'ca';
    else if ( window.location.href.indexOf("/en/") != -1 ) return 'en';
    else if ( window.location.href.indexOf("/fr/") != -1 ) return 'fr';
    else return 'ca';
}



// src banner cookies /////////////////////////////////////////////////////////

var __cookieLawBannerDivId = "cookieLawBannerId";
var __cookieLawCookieBannerShownCountName = "__cookieBannerShownCount";
var __cookieLawCookieAcceptName = "__cookieAccept";
var __cookieLawCountBeforeAccept = 3;

function __showCookieBanner() {
    var divCookieAlert = document.getElementById(__cookieLawBannerDivId);
    if ( divCookieAlert == null ) {
        divCookieAlert = document.createElement("div");
        divCookieAlert.id = __cookieLawBannerDivId;
        divCookieAlert.className = "cookieLawBox";
        divCookieAlert.style.width = "auto";
        divCookieAlert.style.boxSizing = "border-box";
        divCookieAlert.style.padding = "10px 10px 10px 10px";
        divCookieAlert.style.position = "fixed";
        // paso a css: divCookieAlert.style.textAlign = "center";
        if ( __cookieLawBannerPosition == "top" ) {
            divCookieAlert.style.top = "0px";
        } else if ( __cookieLawBannerPosition == "bottom" ) {
            divCookieAlert.style.bottom = "0px";
        }
        divCookieAlert.style.left = "0px";
        divCookieAlert.style.right = "0px";
        divCookieAlert.innerHTML += "<div class=\"message small-12 medium-8 large- column\">"+__cookieLawTextWarning[__getCookieLawLang()]+" <a class=\"cookieLawAnchor no-external-link\" onclick='javascript:__doCookieLawInfo()' target=\"_blank\">"+__cokieLawTextPolCookiesName[__getCookieLawLang()]+"</a></div>";
        
        divCookieAlert.innerHTML += "<div class=\"small-6 medium-2 large-2 column\"><button class=\"cookieLawButton  cookieLawButtonAccept button expanded no-external-link\" style=\"margin-left: 20px; float: right; \" onclick='javascript:__doCookieLawAccept()'>"+__cokieLawTextAccept[__getCookieLawLang()]+"</button></div>";
        divCookieAlert.innerHTML += "<div class=\"small-6 medium-2 large-2 column\"><button class=\"cookieLawButton cookieLawButtonAccept button expanded hollow no-external-link\" style=\"margin-left: 20px; float: right; \" onclick='javascript:__doCookieLawDeny()'>"+__cokieLawTextReject[__getCookieLawLang()]+"</button></div>";
        document.body.appendChild(divCookieAlert);
    }
    // TODO que pasa si no hay firstFchild
}

function __hideCookieBanner() {
    var divCookieAlert = document.getElementById(__cookieLawBannerDivId);
    if ( divCookieAlert != null ) {
        divCookieAlert.parentNode.removeChild(divCookieAlert);
    }
}

function __isVisibleCookieBanner() {
    var divCookieAlert = document.getElementById(__cookieLawBannerDivId);
    if ( divCookieAlert != null )
        return true;
    else
        return false;
}


// control de cookies: info, aceptar, salir ///////////////////////////////////

function __doCookieLawInfo() {
    document.location = __cookieLawCookiePolicyUrl[__getCookieLawLang()];
}

function __doCookieLawAccept() {
    __saveCookieValue(__cookieLawCookieAcceptName,"accepted", 31536000000, "/"); // expiry = 1 year
    __deleteCookieJs(__cookieLawCookieBannerShownCountName);
    __hideCookieBanner();
}

function __doCookieLawAcceptInferred() {
    __saveCookieValue(__cookieLawCookieAcceptName,"accepted", 0, "/"); // expiry = session
    __deleteCookieJs(__cookieLawCookieBannerShownCountName);
    __hideCookieBanner();
}

function __doCookieLawDeny() {
    __saveCookieValue(__cookieLawCookieAcceptName,"denied", 0, "/");
    __hideCookieBanner();
}

function __doCookieLawDenyAndExit() {
    __deleteAllCookiesJs();
    document.body.innerHTML = '';
}

function __doCookieClose() {
    __hideCookieBanner();
}

// alert //////////////////////////////////////////////////////////////////////

function __bodyAlert(textToAlert) {
    var auxAlertP = document.createElement("p");
    auxAlertP.innerHTML = "["+new Date()+" "+textToAlert+"]";
    document.body.appendChild(auxAlertP);

}


// control de scroll //////////////////////////////////////////////////////////


function __getScrollX() {
    var auxX = (window.pageXOffset !== undefined) ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft;
    return auxX;
}


function __getScrollY() {
    var auxY = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop; 
    return auxY;
}


// general cookie management //////////////////////////////////////////////////

// returns the value of the cookie or null if there is not such cookie
function __retrieveCookieValue(cookieName) {
    var auxCookiesString = document.cookie;
    var arrMatches = auxCookiesString.split(";");
    for ( var i = 0; arrMatches != null && i < arrMatches.length; i++ ) {
        if ( arrMatches[i] != null && arrMatches[i].indexOf("=") != -1 ) {
            var auxCookieName = arrMatches[i].substring(0,arrMatches[i].indexOf("="));
            auxCookieName = cookieNameTrim(auxCookieName);
            var auxCookieValue = arrMatches[i].substring(arrMatches[i].indexOf("=")+1);
            if ( auxCookieName == cookieName ) {
                return auxCookieValue;
            }
        }
    }
    return null;
}


function __saveCookieValue(cookieName,cookieValue) {
    document.cookie = cookieName + "=" + cookieValue;
}


// cookieExpirationMilisFromNow == 0 --> session
function __saveCookieValue(cookieName,cookieValue,cookieExpirationMilisFromNow) {
    if ( cookieExpirationMilisFromNow == 0 ) {
        document.cookie = cookieName + "=" + cookieValue + '; expires=0';
    } else {
        var auxDate = new Date();
        var auxTime = auxDate.getTime();
        auxTime = auxTime + cookieExpirationMilisFromNow;
        auxDate.setTime(auxTime);
        document.cookie = cookieName + "=" + cookieValue + '; expires=' + auxDate.toGMTString();
    }
}

// cookieExpirationMilisFromNow == 0 --> session
function __saveCookieValue(cookieName,cookieValue,cookieExpirationMilisFromNow, cookiePath) {
    if ( cookieExpirationMilisFromNow == 0 ) {
        document.cookie = cookieName + "=" + cookieValue + '; expires=0; path=' + cookiePath;
    } else {
        var auxDate = new Date();
        var auxTime = auxDate.getTime();
        auxTime = auxTime + cookieExpirationMilisFromNow;
        auxDate.setTime(auxTime);
        document.cookie = cookieName + "=" + cookieValue + '; expires=' + auxDate.toGMTString() + '; path=' + cookiePath;
    }
}


// method used to remove left and right spaces in cookie name
function cookieNameTrim(s) {
    if ( typeof s === "undefined" ) return s;
    if  ( s == null ) return s;
    var ret = "";
    for ( var i=0; i < s.length; i++ ) {
        if ( s.charAt(i) != " " ) ret = ret + s.charAt(i);
    }
    return ret;
}

function __deleteAllCookiesJs() {
    alert("borrando..."+document.cookie);
    var auxCookieSplit = document.cookie.split(';');
    for (var i=0 ; i < auxCookieSplit.length; i++) {
        var auxCookieName = auxCookieSplit[i].substring(0,auxCookieSplit[i].indexOf("="));
        auxCookieName = cookieNameTrim(auxCookieName);
        __deleteCookieJs(auxCookieName);
    }
}

function __deleteCookieJs(cookieName) {
    document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
    var auxDomain = document.domain;
    var auxSubdomain = auxDomain;
    if ( auxSubdomain.indexOf(".") != -1 ) auxSubdomain = auxSubdomain.substring(auxSubdomain.indexOf(".")+1);
    document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; domain = "+auxSubdomain;
}


// return true if cookies are enabled
function __checkCookiesEnabled(){
    var retCookieEnabled = (navigator.cookieEnabled)? true : false;
    if ( typeof navigator.cookieEnabled =="undefined" && !retCookieEnabled ){
        document.cookie="__auxTestCookie";
        retCookieEnabled=(document.cookie.indexOf("__auxTestCookie")!=-1)? true : false;
        __deleteCookieJs("__auxTestCookie");
    }
    return retCookieEnabled;
}


// cookies to manage baner & consent //////////////////////////////////////////

function __setOrUpdateCookieBannerShownCount() {
    var auxCount = __retrieveCookieValue(__cookieLawCookieBannerShownCountName);
    if ( auxCount == null || isNaN(auxCount) ) {
        __saveCookieValue(__cookieLawCookieBannerShownCountName,""+__cookieLawCountBeforeAccept, 0, "/");
    } 
    else {
        var auxCountNum = parseInt(auxCount);
        auxCountNum = auxCountNum - 1;
        __saveCookieValue(__cookieLawCookieBannerShownCountName,""+auxCountNum, 0, "/");
    }
}


// solo devuelve true si existe la cookie y es mayor que 0
function __testCookieBannerShownCountExceded() {
    var auxCount = __retrieveCookieValue(__cookieLawCookieBannerShownCountName);
    if ( auxCount == null ) {
        return false;
    } else if ( isNaN(auxCount) ) {
        return false;
    } else { // is a number
        if ( auxCount > 0 ) {
            return false;
        } else {
            return true;
        }
    }
}


function __checkCookieLawExists() {
    var auxCookie = __retrieveCookieValue(__cookieLawCookieAcceptName);
    if ( auxCookie != null && ( ( auxCookie == "accepted" ) || ( auxCookie == "denied" ) ) ) {
        return true;
    };
    return false;
}

function __checkCookieLawAccepted() {
    var auxCookie = __retrieveCookieValue(__cookieLawCookieAcceptName);
    if ( auxCookie != null && ( auxCookie == "accepted" ) ) {
        return true;
    };
    return false;
}

function __checkCookieLawDenied() {
    var auxCookie = __retrieveCookieValue(__cookieLawCookieAcceptName);
    if ( auxCookie != null && ( auxCookie == "denied" ) ) {
        return true;
    };
    return false;
}


// banner activation //////////////////////////////////////////////////////////

if ( __checkCookiesEnabled() ) {
    if ( __checkCookieLawExists() == false ) { // show banner if no cookie
        __setOrUpdateCookieBannerShownCount();
        if ( __testCookieBannerShownCountExceded() ) { // count exceded
            __doCookieLawAcceptInferred();
        } else {
            __showCookieBanner();
        }
    }
};